"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Protected = exports.FirebaseProtected = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const provider_user_1 = require("@framework/provider-user");
const FirebaseProtected = props => {
    const { children } = props;
    const [isReady, setIsReady] = (0, react_1.useState)(false);
    const user = (0, provider_user_1.useUser)();
    const location = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(() => {
        const id = setTimeout(() => setIsReady(true), 100);
        return () => clearTimeout(id);
    }, []);
    if (!isReady) {
        return null;
    }
    if (!user.isAuthenticated()) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/login" });
    }
    if (!user.isAdmin() && location.pathname === "/users") {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/dashboard" });
    }
    return children ? (0, jsx_runtime_1.jsx)(react_1.Fragment, { children: children }) : (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {});
};
exports.FirebaseProtected = FirebaseProtected;
exports.Protected = exports.FirebaseProtected;
//# sourceMappingURL=index.js.map